import axios from 'axios'
var cliente = axios.create({
  baseURL: process.env.VUE_APP_CREDIGITAL_SERVICE,
  headers: {
    'Content-Type': 'application/json-patch+json',
    accept: 'text/plain',
    'Access-Control-Allow-Origin': '*',
  },
})
export { cliente }
